import classNames from 'classnames'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import colors from '../../assets/styles/globals.scss'

import './Tooltip.scss'

const Tooltip = ({ className, ...otherProps }) => (
  <div className='Tooltip'>
    <ReactTooltip
      type='light'
      events='click'
      effect='solid'
      place='top'
      border={true}
      borderColor={colors.placeholderGray}
      arrowColor={colors.placeholderGray}
      className={classNames('custom-tooltip', className)}
      bodyMode
      {...otherProps}
    />
  </div>
)

Tooltip.propTypes = {
  className: PropTypes.string,
}

export default Tooltip
